import { h } from 'preact';
import type { BusinessIconImageProps } from '../businessTypes';

type FilterEventFilledProps = BusinessIconImageProps & {
  secondaryColor?: string;
};

const FilterEventFilled = ({ size = 24, width, height, alt = '', color = 'currentColor', strokeWidth, style, ...props }: FilterEventFilledProps) =>
  h(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 24 24',
      fill: color,
      width: width ?? size,
      height: height ?? size,
      role: alt ? 'img' : undefined,
      'aria-label': alt || undefined,
      'aria-hidden': alt ? undefined : true,
      color,
      "stroke-width": strokeWidth,
      style,
      ...props,
    },
    [
      h(
        'g',
        {
          transform: 'translate(-1.142857 -1.142856) scale(1.642855)',
        },
        [
          h(
            'path',
            {
              d: 'M14.7939 5.80861C15.2342 6.24887 14.9224 7.00163 14.2997 7.00163H8.99837V6.99091H4.7054C4.31943 6.99091 4.00655 6.67802 4.00655 6.29205V4.69467C4.00655 4.3087 4.31943 3.99581 4.7054 3.99581H8.99837V1.70026C8.99837 1.07764 9.75114 0.765836 10.1914 1.20609L14.7939 5.80861Z',
            },
          ),
          h(
            'path',
            {
              d: 'M1.20609 10.1914C0.765837 9.75113 1.07764 8.99836 1.70026 8.99836L7.00163 8.99837V9.00812H11.2946C11.6806 9.00812 11.9935 9.321 11.9935 9.70697V11.3044C11.9935 11.6903 11.6806 12.0032 11.2946 12.0032H7.00163V14.2997C7.00163 14.9224 6.24886 15.2342 5.80861 14.7939L1.20609 10.1914Z',
            },
          ),
        ],
      ),
    ],
  );

export default FilterEventFilled;
